@if (dataLineList) {
  <div class="grid">
    <div class="col-12">
      <p-divider align="center">
        <span class="p-tag">{{ title }}</span>
      </p-divider>
      <table class="table" style="font-size: 14px">
        <tbody>
          @for (dataLine of dataLineList; track dataLine.name || dataLine.Name) {
            <tr>
              @if (dataLine.Label) {
                <td class="label pad">
                  {{ dataLine.Label }}
                </td>
              } @else {
                <td class="pad">
                  {{ dataLine.name }}
                </td>
              }
              <td class="pad">
                {{ dataLine.value }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
